import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import LightbulbDim from './icon-lightbulb-dim.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <LightbulbDim {...validProps} />;
}
SvgComponent.iconName = 'lightbulb-dim';

/**
 * @deprecated This is a legacy icon
 */
export const LightbulbDimIcon = svgIconWrapper(SvgComponent);
